export default {
	title: 'Disabled elements',
	empty: 'No disabled elements in this scenario',
	no_scenario: 'Select a scenario to see disabled elements'
};
